import { useQueryClient } from "@tanstack/react-query";
import { Checkbox, Form, Modal, Select, Typography } from "antd";
import { Cancel, Reset, Save } from "components/UI";
import { useAntdMessage } from "hooks/useAntdMessage";
import { useCallback, useMemo } from "react";
import localStore from "store";
import { setBaseUrl } from "utils/axios";
import { generateBaseUri } from "utils/helper";

const BASE_URL_OPTIONS = [
  "https://api.kledo.com/api/v1",
  "https://app.kledo.test/api/v1",
  "https://api.jokolodang.com/api/v1",
];

const ChangeEnvModal = ({ open, onCancel }) => {
  const queryClient = useQueryClient();
  const { message } = useAntdMessage(); //

  const initialValues = useMemo(() => {
    const isOverwriteBaseUrl = localStore.get("app.isOverwriteBaseUrl");
    return {
      base_url:
        localStore.get("app.bypassEndpoint") || import.meta.env.VITE_API_URL,
      overwrite_baseurl:
        typeof isOverwriteBaseUrl !== "undefined" ? isOverwriteBaseUrl : true,
    };
  }, []);

  const submitHandler = useCallback(
    (values) => {
      localStore.set("app.bypassEndpoint", values.base_url);
      localStore.set("app.isOverwriteBaseUrl", values.overwrite_baseurl);
      queryClient.clear();
      setBaseUrl(values.base_url);
      message.success("Base URL berhasil diganti");
      onCancel();
    },
    [onCancel, queryClient, message]
  );

  const resetHandler = useCallback(() => {
    localStore.set("app.bypassEndpoint", "");
    localStore.set("app.isOverwriteBaseUrl", false);
    queryClient.clear();
    setBaseUrl(generateBaseUri());
    message.success("Base URL berhasil direset");
    onCancel();
  }, [onCancel, queryClient, message]);

  return (
    <Modal
      title="Ganti Base Url"
      open={open}
      destroyOnHidden
      onCancel={onCancel}
      maskTransitionName=""
      maskClosable={false}
      footer={[
        <Cancel key="cancel" onClick={onCancel} />,
        <Reset type="success" key="reset" onClick={resetHandler} />,
        <Save form="changeEnvForm" key="submit" htmlType="submit" />,
      ]}
    >
      <Form
        initialValues={initialValues}
        layout="vertical"
        name="changeEnvForm"
        onFinish={submitHandler}
      >
        <Form.Item
          rules={[{ required: true, message: "Silahkan masukkan base url" }]}
          name="base_url"
          label="Base URL"
        >
          <Select
            showSearch
            allowClear
            autoFocus
            mode="combobox"
            placeholder="contoh: https://api.jokolodang.com/v1/api"
            options={BASE_URL_OPTIONS.map((url) => ({ value: url, label: url }))}
            filterOption={(input, option) =>
              option.value.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
        <Form.Item name="overwrite_baseurl" valuePropName="checked">
          <Checkbox>
            <Typography.Text strong>
              Jika dicentang, hanya berlaku untuk login yang memiliki 1
              perusahaan. Overwrite disini artinyaa baseurl yang diinputkan akan
              mengganti endpoint di response init.
            </Typography.Text>
          </Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangeEnvModal;
